export const handleError = (err: unknown, message: string): Error => {
    if (err instanceof Error) {
        return err;
    }
    return new Error(message);
};
